<template>
  <div class="content-item" v-for="item in content" :key="item.id">
    <div class="title">
      {{ item.title }}
    </div>
    <div class="description">
      {{ item.description }}
    </div>
  </div>
</template>

<script>
export default {
  name: "type-uav-item",
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-top: 1px solid #1c1c1c;
  height: 192px;
  padding-top: 22px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding-bottom: 27px;
    height: 115px;
  }

  &:last-child {
    border-bottom: 1px solid #1c1c1c;
  }

  .title {
    font-family: "UAF Sans H", serif;
    font-weight: 500;
    font-size: 24px;
    line-height: 100%;
    text-transform: uppercase;
  }

  .description {
    font-family: UAF Sans;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    max-width: 488px;

    @media (max-width: 767px) {
      font-size: 18px;
    }
  }
}
</style>
